import React from 'react';
import ClinicalNoteSection from '../../../../global/component/ClinicalNote/ClinicalNoteSection';
import { ClinicalNoteType } from '../../../../global/entities/ClinicalNote/ClinicalNote';

interface PhysicalExaminationSectionProps {
    patientId?: string | number;
    patientName?: string | null;
    patientDateOfBirth?: string | null;
}

const PhysicalExaminationSection: React.FC<PhysicalExaminationSectionProps> = (props) => (
    <ClinicalNoteSection
        config={{
            noteType: ClinicalNoteType.PhysicalExam,
            i18nPrefix: 'physicalExamination',
            editRouteSegment: 'physicalExamination',
            showSendToAssistant: true,
        }}
        {...props}
    />
);

export default PhysicalExaminationSection;
